<template>
  <v-layout style="max-width: 100%;">
    <v-avatar class="shrink mx-2 my-1" size="15">
      <v-img :src="imageInfo.thumbnailUrl"></v-img>
    </v-avatar>
    <v-layout column>
      <div class="truncate">
        <span class="subheading font-weight-bold">{{ imageInfo.name }}</span>
      </div>
      <v-layout align-content-start>
        <div class="caption pr-2">
          {{ imageInfo.size }}
        </div>
        <div class="caption pl-2">
          <v-icon x-small>label</v-icon>
          <template v-for="tag in resource.tags.userDefined">
            {{ tag.text }}
          </template>
        </div>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: {
    resource: { default: () => ({}) },
    imageInfo: { default: () => ({}) }
  }
};
</script>

<style>
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
